import { makeEntityId } from '@web-platform/shared-universal-types-utils/src/utils';

import type { RadarAirports } from '@web-platform/shared-universal-types/src/network/endpoints/radar/radarFilterTypes';
import type { AirportsStats } from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/features/filters/airportsStats';

export const mapAirportsStats = (airports: RadarAirports): AirportsStats =>
  airports.reduce<AirportsStats>((acc, section) => {
    acc[section.city] = section.airports.map(({ entityId, id, name }) => ({
      id,
      entityId: makeEntityId(entityId),
      name,
    }));
    return acc;
  }, {});
